<template>
<div class="profile-section w-100 bg-white" :class="{ collapsed : collapseProfileSection }">
  <div class="section-wrapper">
    <div class="section-header border-bottom py-3" @click="toggleProfileSection">
      <div class="px-4 d-flex align-items-center justify-content-between">
        <h6 class="text-primary text-uppercase mb-0">
          {{ myName }}
        </h6>
        <button class="p-0 btn btn-link">
          <i class="fas text-primary" :class="[ collapseProfileSection ? 'fa-chevron-up' : 'fa-chevron-down' ]"></i>
        </button>
      </div>
    </div>
    <transition
      name="profileTransition"
      v-on:before-enter="beforeEnterProfile" v-on:enter="enterProfile"
      v-on:before-leave="beforeLeaveProfile" v-on:leave="leaveProfile"
    >
      <ul class="mb-2 menu-items-list px-4 pb-3 profile-section-content pt-3" v-if="!collapseProfileSection">
        <li>
          <button class="pl-0 py-2 btn btn-link" @click="profile">
            <i class="icon fas fa-pencil-alt text-primary"></i>
            <span class="text-primary">Modifica Profilo</span>
          </button>
        </li>
        <li>
          <button class="pl-0 py-2 btn btn-link" @click="changePassword">
            <i class="icon fas fa-key text-primary"></i>
            <span class="text-primary">Modifica Password</span>
          </button>
        </li>
        <li>
          <button class="pl-0 py-2 btn btn-link" @click="logout" v-close-menu>
            <i class="icon fas fa-sign-out-alt text-danger"></i>
            <span class="text-danger">Logout</span>
          </button>
        </li>
      </ul>
    </transition>
  </div>

  <BModal title="Profilo" dialog-class="modal--type-dialog" id="profile-modal" ref="profile-modal" hide-footer centered scrollable>
    <AccountForm :edit="true" :user="user" />
  </BModal>

  <BModal title="Cambia Password" dialog-class="modal--type-dialog" id="change-password-modal" ref="change-password-modal" hide-footer centered scrollable>
    <ProfilePasswordChangeForm />
  </BModal>

  <BModal dialog-class="modal--type-dialog" id="error-modal" ref="error-modal" centered scrollable>
    Si è verificato un errore durante il recupero dell'utente, si prega di riprovare
    <template #modal-footer>
      <button class="ml-2 btn btn-outline-danger" @click="close('error-modal')">Chiudi</button>
    </template>
  </BModal>
</div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import closeMenuDirective from '../../../../libs/Sidebar/directives/closeMenu';

export default {
  name: 'profile-section',
  components: {
    BModal,
    AccountForm: () => import('../../Account/AccountForm'),
    ProfilePasswordChangeForm: () => import('../../Account/ProfilePasswordChangeForm'),
  },
  directives: {
    closeMenu: closeMenuDirective,
  },
  data () {
    return {
      collapseProfileSection: true,
      showIconsOnly: false,
      showChildrenLinks: false,
      user: null,
    };
  },
  computed: {
    myName () {
      return this.$oauth2?.me?.name;
    },
    showContextSelect () {
      return this.$oauth2.me && (this.$oauth2.me.companies?.length || 0) > 1;
    },
  },
  methods: {
    toggleProfileSection () {
      this.collapseProfileSection = !this.collapseProfileSection;
    },
    beforeEnterProfile (el) {
      el.style.height = '0';
    },
    enterProfile (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeaveProfile (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leaveProfile (el) {
      el.style.height = '0';
    },
    logout () {
      this.$router.push({ name: 'logout' });
    },
    async profile () {
      try {
        const res = await this.$api.getMyProfile();
        this.user = res.data;
        this.$refs['profile-modal'].show();
      } catch (error) {
        this.$refs['error-modal'].show();
      }
    },
    changePassword () {
      this.$refs['change-password-modal'].show();
    },
  },
};
</script>

<style lang="scss" scoped>
$mobile-profile-section-height: 60px !default;

.profile-section {
  position: absolute;
  bottom: 0;

  &:not(.collapsed) {
    box-shadow: 0px -3px 18px 3px rgba(0,0,0,.18);
  }

  .section-header {
    height: $mobile-profile-section-height;
  }

  .profile-section-content {
    transition: 150ms ease-out;
  }
}
</style>
